

const state = () => ({
    _current: null,
});

const getters = {
    toast: (state) => state._current,
};

const actions = {
    /**
     * Sets the given toast so it can be displayed.
     *
     * @param {Object} toast
     * @return {void}
     */
    showToast(toast) {
        this._setToastShow(toast);
    },

    _setToastShow(toast) {
        this._current = toast;
    },
};



export default {
    state,
    getters,
    actions,
};
